import React from 'react'
import { IProps } from './index'
import classNames from 'classnames'
import { mq, useMediaQuery } from '../../utils'
import { ImageOrAutoplayVideo } from 'marketing-site/src/library/elements/ImageOrAutoplayVideo'

export const HeroAnimation: React.FC<IProps> = ({
  firstImage,
  firstAnimation,
  firstMobileImage,
  firstMobileAnimation,
  secondImage,
  secondAnimation,
  secondMobileImage,
  secondMobileAnimation,
  teamMode = true,
}) => {
  const backgroundTeam = classNames('hero-animation', {
    'hero-animation--background-customer': !teamMode,
    'hero-animation--background-teams': teamMode,
  })

  const customerClasses = classNames('hero-animation__lottie-container', {
    'hero-animation__lottie-container--off': !teamMode,
  })

  const teamsClasses = classNames('hero-animation__lottie-container', {
    'hero-animation__lottie-container--off': teamMode,
  })

  const isMobile = useMediaQuery(`(${mq.mobile})`)

  return (
    <>
      <div className={backgroundTeam}>
        <div className={customerClasses}>
          {isMobile ? (
            <ImageOrAutoplayVideo
              video={firstMobileAnimation}
              imageRef={firstMobileImage}
              forcedAnimationState={teamMode ? 'play' : 'stop'}
            />
          ) : (
            <ImageOrAutoplayVideo
              video={firstAnimation}
              imageRef={firstImage}
              forcedAnimationState={teamMode ? 'play' : 'stop'}
            />
          )}
        </div>
        <div className={teamsClasses}>
          {isMobile ? (
            <ImageOrAutoplayVideo
              video={secondMobileAnimation}
              imageRef={secondMobileImage}
              forcedAnimationState={!teamMode ? 'play' : 'stop'}
            />
          ) : (
            <ImageOrAutoplayVideo
              video={secondAnimation}
              imageRef={secondImage}
              forcedAnimationState={!teamMode ? 'play' : 'stop'}
            />
          )}
        </div>
      </div>
      <style jsx>
        {`
          .hero-animation {
            display: grid;
            grid-template-columns: 1fr;
            justify-items: center;
            align-content: center;
            padding: 0 30px;
            position: relative;
            &__lottie-container {
              grid-row-start: 1;
              grid-column-start: 1;
              transform: translateX(0);
              opacity: 1;
              transition: transform 1s, opacity 1s;
              &--off {
                transform: translateX(100%);
                opacity: 0;
              }
            }
          }

          @media (${mq.laptop}) {
            .hero-animation {
              padding: 0;
              justify-items: center;
              &--background-teams::before,
              &--background-customer::before {
                transform: scale(1.2) translate(5%, 3%);
              }

              &__lottie-container {
                padding: 0;
                margin: 0 0 0 auto;
              }
            }
          }

          @media (${mq.desktop}) {
            .hero-animation {
              flex: 1 1 60%;
              &--background-teams::before,
              &--background-customer::before {
                transform: scale(1.25) translate(2.5%, 2.5%);
              }
            }
          }

          @media (${mq.desktopLg}) {
            .hero-animation {
              flex: 1 1 75%;
              &--background-teams {
                transform: translateX(20px);
              }
            }
          }
        `}
      </style>
    </>
  )
}
